<template>
  <div
    :class="{ 'is-active': active }"
    class="modal"
    @keypress.esc="close"
  >
    <div
      class="modal-background"
      @click.stop="close"
    ></div>
    <div class="modal-content">
      <!-- @slot Content of the modal, make sure to apply a background color -->
      <slot></slot>
    </div>
    <button
      type="button"
      v-if="showClose"
      @click.stop="close"
      class="modal-close is-large"
      title="close modal"
    ></button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/** A modal */
export default defineComponent({
  props: {
    /** When true the Modal opens */
    active: {
      type: Boolean,
      required: true,
    },
    /** When false does not show the close button */
    showClose: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    active(isOpened) {
      if (isOpened) {
        document.addEventListener("keyup", this.escapeClose)
        return
      }
      document.removeEventListener("keyup", this.escapeClose)
    }
  },
  methods: {
    close() {
      /** Caller should set the `active` prop to false */
      this.$emit("close")
    },
    escapeClose(e: KeyboardEvent) {
      if (e.key === "Escape") {
        this.close()
      }
    }
  }
})
</script>
